import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetSettingsControlBase } from '../control-base';
import {
    ForumListingSettingsDescriptionLimitIds,
    ForumListingSettingsDescriptionLimitOptions,
} from '@fi-app/widget-settings/controls/forum-listing/description-limit-options';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'widget-settings-control-forum-listing',
    templateUrl: './forum-listing.component.html',
    styleUrls: ['./forum-listing.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'widget-settings-control-forum-listing' },
    standalone: false,
})
export class WidgetSettingsControlForumListingComponent extends WidgetSettingsControlBase implements OnInit {
    readonly ForumListingSettingsDescriptionLimitOptions = ForumListingSettingsDescriptionLimitOptions;

    ngOnInit() {
        if (!isDefined(this.Settings.DescriptionLimit)) {
            this.Settings.DescriptionLimit = ForumListingSettingsDescriptionLimitIds.Medium;
        }
    }
}
